class Routes {
    public static readonly Index = '/';
    public static readonly Login = '/login';
    public static readonly Register = '/register';
    public static readonly Room = '/room/:roomId/';
    public static readonly VotingHistory = '/room/:roomId/history';
}
export default Routes;
